import React from 'react';

const LongDash = () => (
  <svg
    width="30"
    height="3"
    viewBox="0 0 30 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="29"
      y1="1.5"
      x2="1"
      y2="1.5"
      stroke="#484848"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default LongDash;
